import { useEffect, useState } from 'react';
import { isValidResponseEntity } from '@helpers/utils';
import { getInvestorAppNudge } from '@services/investors.service';

export const useAppNudgeVisibility = ({
    investorId,
    path,
    shouldFetch = true,
}) => {
    const [showAppNudge, setShowAppNudge] = useState(false);
    const [isLoading, setIsLoading] = useState(true);
    const fetchNudge = async () => {
        try {
            const response = await getInvestorAppNudge(investorId);

            if (isValidResponseEntity(response)) {
                const shouldShow =
                    response.entity?.[path]?.shouldShowNudge ?? false;
                setShowAppNudge(shouldShow);
            } else {
                setShowAppNudge(false);
            }
        } catch (err) {
            setShowAppNudge(false);
        } finally {
            setIsLoading(false);
        }
    };

    useEffect(() => {
        if (investorId && shouldFetch) {
            fetchNudge();
        } else {
            setShowAppNudge(false);
            setIsLoading(false);
        }
    }, [investorId]);

    return { showAppNudge, isLoading };
};
